module.exports = __webpack_public_path__ + "img/align-horizontal-left.d8a70628.svg";